import React from 'react'
import PropTypes from 'prop-types'

import { optionListItemStyle, hiddenAnchorStyle, flexMiddle } from '../styles'

import RadioInput from '../RadioInput/RadioInput'

const OptionListItemRadio = ({ id, isSelected, onClick, label, labelLine2, children, disabled = false }) => (
    <div key={id} style={optionListItemStyle}>
        <div className='d-flex' onClick={(e) => { e.preventDefault(); if (!disabled) { onClick(id) }; }}>
            <RadioInput selected={isSelected} style={flexMiddle} onClick={() => onClick(id)} disabled={disabled} />
            <button className='btn btn-link' style={hiddenAnchorStyle} disabled={disabled}>
                {label}
                {!!labelLine2 &&
                    <React.Fragment>
                        <br />
                        {labelLine2}
                    </React.Fragment>
                }
            </button>
        </div>
        {children}
    </div>);


OptionListItemRadio.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired
}

export default OptionListItemRadio